import { render, staticRenderFns } from "./TagButton.vue?vue&type=template&id=788f0965&scoped=true&"
import script from "./TagButton.vue?vue&type=script&lang=ts&"
export * from "./TagButton.vue?vue&type=script&lang=ts&"
import style0 from "./TagButton.vue?vue&type=style&index=0&id=788f0965&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788f0965",
  null
  
)

export default component.exports